import { stringify } from 'qs';
import { languageSlug, Language, getAllowedLanguages } from '../stores/LanguageStore';
import { hasCurrentHost, toPath } from './PathUtil';

export interface SearchParams {
  [param: string]: string | string[];
}

export const extractHyperlink = (url: string): HTMLHyperlinkElementUtils => {
  const link = document.createElement('a');
  link.href = url;
  return link;
};

export const putSearchIfMissing = (link: HTMLHyperlinkElementUtils, search: SearchParams) => {
  if (link.search && search) {
    console.warn(`Url ${link.href} already had search params, ignoring specified ${JSON.stringify(search)}`);
    return;
  }
  if (search) {
    link.search = stringify(search, { addQueryPrefix: true, arrayFormat: 'repeat' });
  }
};

export const pathnameFromUrl = (url: string): string => {
  return extractHyperlink(url).pathname || '/';
};

export const urlWithLang = (url: string, lang: Language) => {
  const link = extractHyperlink(url || '');
  putLangIfLocal(link, lang);

  return url && url.startsWith(`${link.protocol}//${link.host}`) ? link.href : link.pathname + link.search + link.hash;
};

export const pathStartsWithLang = (path: string[]): boolean => {
  return path && path.length > 0 && getAllowedLanguages().includes(path[0]);
};

export const langFromPath = (path: string[]): Language => {
  return pathStartsWithLang(path) ? (path[0] as Language) : null;
};

export const langFromUrl = (url: string): Language => {
  return langFromPath(toPath(pathnameFromUrl(url)));
};

export const putLangIfLocal = (link: HTMLHyperlinkElementUtils, lang: Language) => {
  if (!hasCurrentHost(link)) {
    return;
  }

  const langSlug = languageSlug(lang);
  if (langSlug) {
    link.pathname = langSlug + link.pathname;
  }
};
